<nz-spin [nzSpinning]="loading">
  @if (stores$ | async; as stores) {
    <nz-tabs>
      <nz-tab nzTitle="Übersicht">
        <nz-row>
          <form nz-form [formGroup]="form" (ngSubmit)="submitForm()" style="width: 100%">
            <nz-form-item>
              <nz-form-label [nzSm]="6" [nzXs]="24" nzFor="name">
                <span>Name</span>
              </nz-form-label>
              <nz-form-control [nzSm]="14" [nzXs]="24" nzErrorTip="Bitte geben Sie den Artikelnamen ein!">
                <input nz-input id="name" formControlName="name" />
              </nz-form-control>
            </nz-form-item>
            <nz-form-item>
              <nz-form-label [nzSm]="6" [nzXs]="24" nzFor="orderNumber">
                <span>Bestellnummer</span>
              </nz-form-label>
              <nz-form-control [nzSm]="14" [nzXs]="24" nzErrorTip="Bitte Bestellnummer eingeben!">
                <input nz-input id="orderNumber" formControlName="orderNumber">
              </nz-form-control>
            </nz-form-item>
            <nz-form-item>
              <nz-form-label [nzSm]="6" [nzXs]="24" nzFor="shortDescription">
                <span>Kurzbeschreibung</span>
              </nz-form-label>
              <nz-form-control [nzSm]="14" [nzXs]="24" nzErrorTip="Bitte geben Sie eine kurze Beschreibung ein!">
                <textarea nz-input id="shortDescription" formControlName="shortDescription"></textarea>
              </nz-form-control>
            </nz-form-item>
            <nz-form-item>
              <nz-form-label [nzSm]="6" [nzXs]="24" nzFor="supplierId">
                <span>Lieferant</span>
              </nz-form-label>
              <nz-form-control [nzSm]="14" [nzXs]="24">
                <nz-select formControlName="supplierId" [nzShowSearch]="true">
                  @for (type of (suppliers$ | async); track type) {
                    <nz-option [nzLabel]="type.value" [nzValue]="type.id"></nz-option>
                  }
                </nz-select>
              </nz-form-control>
            </nz-form-item>
            <nz-form-item>
              <nz-form-label [nzSm]="6" [nzXs]="24" nzFor="ean">
                <span>EAN</span>
              </nz-form-label>
              <nz-form-control [nzSm]="14" [nzXs]="24" nzErrorTip="Bitte geben Sie EAN ein!">
                <input nz-input id="ean" formControlName="ean" type="number" />
              </nz-form-control>
            </nz-form-item>
            <nz-form-item>
              <nz-form-label [nzSm]="6" [nzXs]="24" nzFor="weight">
                <span>Gewicht</span>
              </nz-form-label>
              <nz-form-control [nzSm]="14" [nzXs]="24">
                <input nz-input id="weight" formControlName="weight" type="number" />
              </nz-form-control>
            </nz-form-item>
            <nz-form-item>
              <nz-form-label [nzSm]="6" [nzXs]="24" nzFor="purchaseUnit">
                <span>Inhalt</span>
              </nz-form-label>
              <nz-form-control [nzSm]="14" [nzXs]="24">
                @if (units[editObject?.defaultArticleVariant?.unitId]) {
                  <nz-input-group [nzAddOnAfter]="units[editObject.defaultArticleVariant.unitId]">
                    <input nz-input id="purchaseUnit" formControlName="purchaseUnit" type="number" />
                  </nz-input-group>
                } @else {
                  <input nz-input id="purchaseUnit" formControlName="purchaseUnit" type="number" />
                }
              </nz-form-control>
            </nz-form-item>
            <nz-form-item>
              <nz-form-label [nzSm]="6" [nzXs]="24" nzFor="packUnit">
                <span>Verpackungseinheit</span>
              </nz-form-label>
              <nz-form-control [nzSm]="14" [nzXs]="24">
                <input nz-input id="packUnit" formControlName="packUnit" type="text" />
              </nz-form-control>
            </nz-form-item>
            @if (false) {
              <nz-row nzJustify="center">
                <nz-col [nzSm]="6" [nzXs]="12">
                  <nz-form-item>
                    <nz-form-label nzFor="checked">
                      <span>ist Variante</span>
                    </nz-form-label>
                    <nz-form-control>
                      <label
                        class="verify-checkbox"
                        nz-checkbox
                        formControlName="hasVariants"
                        (nzCheckedChange)="checkedChanged()"
                        >
                        Ja/Nein
                      </label>
                    </nz-form-control>
                  </nz-form-item>
                </nz-col>
                <nz-col [nzSm]="6" [nzXs]="12">
                  <nz-form-item>
                    <nz-form-label nzFor="isGiftbox">
                      <span>Geschenkset</span>
                    </nz-form-label>
                    <nz-form-control>
                      <label
                        class="verify-checkbox"
                      nz-checkbox formControlName="isGiftbox" (nzCheckedChange)="selectedGiftboxArticles = []">Ja/Nein</label>
                    </nz-form-control>
                  </nz-form-item>
                </nz-col>
              </nz-row>
            }
            @if (false) {
              <nz-row nzJustify="center">
                <nz-col [nzSm]="6" [nzXs]="12">
                  <nz-form-item>
                    <nz-form-label nzFor="checked">
                      <span>ist Bio</span>
                    </nz-form-label>
                    <nz-form-control>
                      <label
                        class="verify-checkbox"
                      nz-checkbox formControlName="isBio">Ja/Nein</label>
                    </nz-form-control>
                  </nz-form-item>
                </nz-col>
                <nz-col [nzSm]="6" [nzXs]="12"></nz-col>
              </nz-row>
            }
            @if (form.controls['isGiftbox'].value && (!form.controls.hasVariants.value)) {
              <nz-form-item class="formula">
                <nz-form-label [nzXs]="24" style="text-align: left">
                  <span>Geschenkset-Formel</span>
                </nz-form-label>
                <nz-form-control [nzXs]="24" [nzSm]="12">
                  <ul nz-list [nzDataSource]="selectedGiftboxArticles" nzBordered nzSize="large" class="form-control form-control--selected-articles">
                    <nz-list-header>ausgewählte Artikel</nz-list-header>
                    @for (item of selectedGiftboxArticles; track item; let i = $index) {
                      <li nz-list-item nzNoFlex class="article-item">
                        <ul nz-list-item-actions>
                          <nz-list-item-action>
                            <i
                              nz-icon
                              nzType="close"
                              nzTheme="outline"
                              (click)="removeGiftboxFromList(i)"
                              nz-tooltip
                              nzTooltipTitle="Geschenkset aus der Liste entfernen"
                            ></i>
                          </nz-list-item-action>
                        </ul>
                        {{ item.fullName }}
                      </li>
                    }
                  </ul>
                </nz-form-control>
                <nz-form-control [nzXs]="24" [nzSm]="12">
                  @if (giftboxFormulaArticles$ | async; as articles) {
                    <ul nz-list [nzDataSource]="articles" nzBordered nzSize="large">
                      <nz-list-header>alle Artikel <app-table-search-bar (search)="searchGiftboxArticles($event)" [searchValue]="gitboxSearch"></app-table-search-bar></nz-list-header>
                      @for (item of articles; track item) {
                        <li nz-list-item nzNoFlex class="article-item">
                          <ul nz-list-item-actions>
                            <nz-list-item-action>
                              <i
                                nz-icon
                                nzType="arrow-left"
                                nzTheme="outline"
                                (click)="addGiftboxToList(item)"
                                nz-tooltip
                                nzTooltipTitle="Geschenkset zur Liste hinzufügen"
                              ></i>
                            </nz-list-item-action>
                          </ul>
                          {{ item.fullName }}
                        </li>
                      }
                    </ul>
                  }
                </nz-form-control>
              </nz-form-item>
            }
            <nz-divider></nz-divider>
            <div>
              <nz-form-item>
                <nz-form-label [nzSm]="6" [nzXs]="24" nzNoColon>
                  <b>Großgebinde</b>
                </nz-form-label>
                <nz-form-control [nzSm]="14" [nzXs]="24"></nz-form-control>
              </nz-form-item>
              <nz-form-item>
                <nz-form-label [nzSm]="6" [nzXs]="24" nzNoColon></nz-form-label>
                <nz-form-control [nzSm]="14" [nzXs]="24">
                  <nz-row style="gap: 24px;" nzJustify="space-between">
                    <nz-col>
                      <nz-form-item>
                        <nz-form-label nzFor="isBagable">
                          <span>verpackbar</span>
                        </nz-form-label>
                        <nz-form-control>
                          <label
                            class="verify-checkbox"
                            nz-checkbox
                            formControlName="isBagable"
                            (nzCheckedChange)="disableIsNonPackable()"
                          >Ja/Nein</label>
                        </nz-form-control>
                      </nz-form-item>
                    </nz-col>
                    <nz-col>
                      <nz-form-item>
                        <nz-form-label nzFor="isOwnProduction">
                          <span>eigene Produktion</span>
                        </nz-form-label>
                        <nz-form-control>
                          <label
                            class="verify-checkbox"
                            nz-checkbox
                            formControlName="isOwnProduction"
                            (nzCheckedChange)="selectedArticles = []; disableIsNonPackable();"
                            >
                            Ja/Nein
                          </label>
                        </nz-form-control>
                      </nz-form-item>
                    </nz-col>
                    <nz-col>
                      <nz-form-item>
                        <nz-form-label nzFor="noWeightForProduction">
                          <span>kein Gewicht für die Produktion</span>
                        </nz-form-label>
                        <nz-form-control>
                          <label
                            class="verify-checkbox"
                            nz-checkbox
                            formControlName="noWeightForProduction"
                            >
                            Ja/Nein
                          </label>
                        </nz-form-control>
                      </nz-form-item>
                    </nz-col>
                  </nz-row>
                </nz-form-control>
              </nz-form-item>
              @if (this.form.controls['isOwnProduction'].value) {
                <nz-form-item class="formula">
                  <nz-form-label [nzXs]="24" style="text-align: left">
                    <span>Rezept eigene Produktion</span>
                  </nz-form-label>
                  <nz-form-control [nzXs]="24" [nzSm]="12">
                    <ul nz-list [nzDataSource]="selectedArticles" nzBordered nzSize="large" class="form-control form-control--selected-articles">
                      <nz-list-header>ausgewählte Artikel</nz-list-header>
                      @for (item of selectedArticles; track item; let i = $index) {
                        <li nz-list-item nzNoFlex class="article-item">
                          <ul nz-list-item-actions>
                            <nz-list-item-action>
                              <i
                                nz-icon
                                nzType="close"
                                nzTheme="outline"
                                (click)="removeOwnProductionFromList(i)"
                                nz-tooltip
                                nzTooltipTitle="Artikel aus der Liste entfernen"
                              ></i>
                            </nz-list-item-action>
                          </ul>
                          {{ item.ingredientArticle.value }}
                        </li>
                      }
                    </ul>
                  </nz-form-control>
                  <nz-form-control [nzXs]="24" [nzSm]="12">
                    @if (articles$ | async; as articles) {
                      <ul nz-list [nzDataSource]="articles" nzBordered nzSize="large">
                        <nz-list-header>
                          alle Artikel <app-table-search-bar (search)="searchOwnProduction($event)" [searchValue]="ownProductionSearch" [minLength]="3"></app-table-search-bar>
                        </nz-list-header>
                        @for (item of articles; track item) {
                          <li nz-list-item nzNoFlex class="article-item">
                            <ul nz-list-item-actions>
                              <nz-list-item-action>
                                <i
                                  nz-icon
                                  nzType="arrow-left"
                                  nzTheme="outline"
                                  (click)="addOwnProductionToList(item)"
                                  nz-tooltip
                                  nzTooltipTitle="Artikel zur Liste hinzufügen"
                                ></i>
                              </nz-list-item-action>
                            </ul>
                            {{ item.ingredientArticle.value }}
                          </li>
                        }
                      </ul>
                    }
                  </nz-form-control>
                </nz-form-item>
              }
            </div>
            <nz-divider></nz-divider>
            <div>
              <nz-form-item>
                <nz-form-label [nzSm]="6" [nzXs]="24" nzNoColon>
                  <b>Fremdmarke</b>
                </nz-form-label>
                <nz-form-control [nzSm]="14" [nzXs]="24"></nz-form-control>
              </nz-form-item>
              <nz-form-item>
                <nz-form-label [nzSm]="6" [nzXs]="24" nzNoColon></nz-form-label>
                <nz-form-control [nzSm]="14" [nzXs]="24">
                  <nz-row style="gap: 24px;" nzJustify="space-between">
                    <nz-col>
                      <nz-form-item>
                        <nz-form-label nzFor="isNonPackable">
                          <span>nicht verpackbar</span>
                        </nz-form-label>
                        <nz-form-control>
                          <label
                            class="verify-checkbox"
                            nz-checkbox
                            formControlName="isNonPackable"
                            (ngModelChange)="isNonPackableChange()"
                            >
                            Ja/Nein
                          </label>
                        </nz-form-control>
                      </nz-form-item>
                    </nz-col>
                    <nz-col>
                      <nz-form-item>
                        <nz-form-label nzFor="needsGermanLabel">
                          <span>deutsches Etikett nötig</span>
                        </nz-form-label>
                        <nz-form-control>
                          <label
                            class="verify-checkbox"
                            nz-checkbox
                            formControlName="needsGermanLabel"
                            >
                            Ja/Nein
                          </label>
                        </nz-form-control>
                      </nz-form-item>
                    </nz-col>
                  </nz-row>
                </nz-form-control>
              </nz-form-item>
            </div>
          </form>
        </nz-row>
      </nz-tab>
      <nz-tab nzTitle="Varianten" [nzDisabled]="!isEdit">
        @if (isEdit) {
          <!--      <app-add-edit-variant-modal-->
          <!--        #modal-->
          <!--        [isGiftbox]="this.form.get('isGiftbox').value"-->
          <!--        [articleId]="editObject.id"-->
        <!--      ></app-add-edit-variant-modal>-->
        <nz-row style="margin-top: 16px;">
          <nz-table
            #tableRef
            style="width: 100%"
            nzShowSizeChanger
            [nzFrontPagination]="false"
            [nzData]="editObject.articleVariants"
            nzSize="small"
            >
            <thead>
              <tr>
                <th nzColumnKey="name">Name, Nummer, EAN, MHD</th>
                <th nzColumnKey="supplierOrderNumber">Bestellnummer<br>des Lieferanten</th>
                <th nzColumnKey="isDefault">Ist Standard</th>
                <th nzColumnKey="isActive">Ist Aktiv<br>in Shopware</th>
                <th nzColumnKey="isActiveForProduction">Ist aktiv für<br>die Produktion</th>
                <th nzColumnKey="isNotRelevantForPacking">Nicht relevant<br>für Abfüllliste</th>
                <th nzColumnKey="customWeight">überschriebenes<br>Produktionsgewicht</th>
                <th nzColumnKey="baseReorderMultiply">Menge shop<br>kartons</th>
                <th nzColumnKey="mhdOfferCounter">MHD Angebote<br>Zähler</th>
                <th nzColumnKey="storageLocationNumber">Infos zur<br>Lagerung</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              @for (variant of editObject.articleVariants; track variant; let i = $index) {
                <tr>
                  <td>
                    <div>{{ variant.name }}</div>
                    <div>{{ variant.orderNumber }}</div>
                    <div>{{ variant.ean }}</div>
                    @if (variant.customWeight || variant.purchaseUnit) {
                      <div>
                        {{ variant.customWeight ? (variant.customWeight + ' g') : (variant.purchaseUnit | unitFormat:units[variant.unitId]) }}
                      </div>
                    }
                    <div class="d-flex align-items-center" style="margin-top: 8px;">
                      {{ variant.mhd ? (variant.mhd | dateFormat) : 'leere MHD' }}
                      <button
                        nz-button
                        nzType="primary"
                        nzSize="small"
                        nzShape="circle"
                        style="margin-left: 8px;"
                        (click)="changeMhdModalComponent.showModal({ articleVariant: variant })"
                        >
                        <i
                          nz-icon
                          nzType="edit"
                          nzTheme="outline"
                          nz-tooltip
                          nzTooltipTitle="MHD ändern"
                        ></i>
                      </button>
                    </div>
                  </td>
                  <td>
                    @if (variant.isEdited) {
                      <input
                        type="text"
                        nz-input
                        [(ngModel)]="variant.supplierOrderNumber"
                        >
                    }
                    @if (!variant.isEdited) {
                      {{ variant.supplierOrderNumber }}
                    }
                  </td>
                  <td>
                    <label
                      nz-checkbox
                      [(ngModel)]="variant.isDefault"
                      [nzDisabled]="true"
                    >Ja/Nein</label>
                  </td>
                  <td>
                    <label
                      nz-checkbox
                      [(ngModel)]="variant.isActive"
                      [nzDisabled]="true"
                    >Ja/Nein</label>
                  </td>
                  <td>
                    <label
                      [disabled]="!variant.isEdited"
                      nz-checkbox
                      [(ngModel)]="variant.isActiveForProduction"
                    >Ja/Nein</label>
                  </td>
                  <td>
                    <label
                      [disabled]="!variant.isEdited"
                      nz-checkbox
                      [(ngModel)]="variant.isNotRelevantForPacking"
                    >Ja/Nein</label>
                  </td>
                  <td>
                    <div class="d-flex align-items-center">
                      @if (variant.isEdited) {
                        <input
                          type="number"
                          nz-input
                          [(ngModel)]="variant.customWeight"
                          appPossitiveNumbers
                          style="width: 100px;"
                          >
                      }
                      @if (!variant.isEdited) {
                        {{ variant.customWeight }}
                      }
                      &nbsp;g
                    </div>
                  </td>
                  <td>
                    <div class="d-flex align-items-center">
                      <label
                        nz-checkbox
                        [class.d-none]="!variant.isEdited"
                        [nzChecked]="baseReorderMultiplyInput.value !== null && variant.baseReorderMultiply"
                        #baseReorderMultiplyCheckbox
                        (nzCheckedChange)="variant.baseReorderMultiply = null"
                      >Ja/Nein</label>
                      <input
                        #baseReorderMultiplyInput
                        type="text"
                        [class.d-none]="!baseReorderMultiplyCheckbox.nzChecked || !variant.isEdited"
                        nz-input
                        [disabled]="!variant.isEdited"
                        [nzStatus]="!variant.baseReorderMultiply ? 'error' : null"
                        style="width: 100px;"
                        appPossitiveNumbers
                        [(ngModel)]="variant.baseReorderMultiply"
                        >
                      @if (!variant.isEdited) {
                        {{ variant.baseReorderMultiply }}
                      }
                    </div>
                  </td>
                  <td>
                    @if (variant.isEdited) {
                      <input
                        type="number"
                        nz-input
                        [(ngModel)]="variant.mhdOfferCounter"
                        appPossitiveNumbers
                        style="width: 80px;"
                        >
                    }
                    @if (!variant.isEdited) {
                      {{ variant.mhdOfferCounter ?? 0 }}
                    }
                  </td>
                  <td>
                    @for (storeLocation of variant.storeLocations; track storeLocation; let last = $last) {
                      <div class="d-flex flex-column" style="gap: 4px;">
                        <div>{{ storeLocation.store.name }}</div>
                        <div>
                          <div>Lagerplatz:&nbsp;@if (!variant.isEdited) {
                            {{ storeLocation.storageLocation ?? '-' }}
                          }</div>
                          @if (variant.isEdited) {
                            <input type="text" nz-input [(ngModel)]="storeLocation.storageLocation" style="width: 100px;">
                          }
                        </div>
                        <div>
                          <div>min Vorrätig:&nbsp;@if (!variant.isEdited) {
                            {{ storeLocation.minInStock ?? '-' }}
                          }</div>
                          @if (variant.isEdited) {
                            <input type="number" nz-input [(ngModel)]="storeLocation.minInStock" style="width: 100px;">
                          }
                        </div>
                      </div>
                      @if (!last) {
                        <nz-divider class="store-locations-divider"></nz-divider>
                      }
                    }
                  </td>
                  <td>
                    <div class="d-flex" style="gap: 5px;">
                      <button
                        nz-button nzType="primary"
                        (click)="(variant.isEdited && baseReorderMultiplyCheckbox.nzChecked && !variant.baseReorderMultiply) ? null : editSaveButtonClick(variant)"
                        >
                        <i
                          nz-icon
                          [nzType]="!variant.isEdited ? 'edit' : 'check'"
                          nzTheme="outline"
                          nz-tooltip
                          nzTooltipTitle="{{ variant.isEdited ? 'Variante speichern' : 'Variante bearbeiten' }}"
                        ></i>
                      </button>
                      @if (variant.isEdited) {
                        <button nz-button nzType="default" (click)="variant.isEdited = false">
                          <i
                            nz-icon
                            nzType="close"
                            nzTheme="outline"
                            nz-tooltip
                            nzTooltipTitle="Abbrechen"
                          ></i>
                        </button>
                      }
                      @if (!variant.isEdited) {
                        <button
                          nz-button
                          nzType="default"
                          nz-tooltip
          nzTooltipTitle="Varianten-Etiketten drucken"
                          (click)="printeArticleVariantLabels(variant.id)"
                          >
                          <i
                            nz-icon
                            nzType="printer"
                            nzTheme="outline"
                          ></i>
                        </button>
                      }
                      @if (!variant.isEdited) {
                        <button
                          nz-button
                          nzType="default"
                          nz-tooltip
                          nzTooltipTitle="Varianten-Etiketten neu laden"
                          (click)="regenerateArticleVariantLabels(variant.id)"
                          >
                          <i
                            nz-icon
                            nzType="reload"
                            nzTheme="outline"
                          ></i>
                        </button>
                      }
                    </div>
                    @if (false) {
                      <div class="actions" style="align-items: center;">
                        <!--                <app-add-edit-variant-modal-->
                        <!--                  #modal-->
                        <!--                  [isGiftbox]="this.form.get('isGiftbox').value"-->
                        <!--                  [articleId]="editObject.id"-->
                        <!--                >-->
                        <!--                    <span trigger>-->
                        <!--                      <i nz-icon nzType="edit"  nzTheme="outline" (click)="modal.showModal(variant)"></i>-->
                      <!--                    </span>-->
                    <!--                </app-add-edit-variant-modal>-->
                    @if (variant.labelKey) {
                      <app-download-document
                        class="print-label-btn"
                        [documentKey]="variant.labelKey"
                        icon="printer"
                      ></app-download-document>
                    }
                  </div>
                }
              </td>
            </tr>
          }
        </tbody>
      </nz-table>
    </nz-row>
        }
  </nz-tab>
  <nz-tab nzTitle="Lager" [nzDisabled]="!isEdit">
    @if (isEdit) {
    <nz-row>
      <nz-table
        #tableRef
        style="width: 100%"
        nzShowSizeChanger
        [nzFrontPagination]="false"
        [nzData]="editObject.articleVariants"
        >
        <thead>
          <tr>
            <th nzColumnKey="id" nzWidth="75px">#ID</th>
            <th nzColumnKey="name">Name</th>
            <th nzColumnKey="orderNumber">Nummer</th>
            <th nzColumnKey="ean">EAN</th>
            @for (store of stores; track store) {
              <th>{{ store.value }}</th>
            }
          </tr>
        </thead>
        <tbody>
          @for (variant of editObject.articleVariants; track variant) {
            <tr>
              <td>{{ variant.id }}</td>
              <td>{{ variant.name }}</td>
              <td>{{ variant.orderNumber }}</td>
              <td>{{ variant.ean }}</td>
              @for (store of stores; track store) {
                <td>
                  <div>{{ variant.stocks | stockByStore:store }}</div>
                  @if (store | isStoreMainOrBbm:false:true) {
                    @if (variant | mainStoreSln; as sln) {
                      <a
                        [routerLink]="['/slns']"
                        [queryParams]="{ sln: sln }"
                      >Lagerplatz: {{ sln }}</a>
                    }
                    @if (!(variant | mainStoreSln)) {
                      <span>Lagerplatz: –</span>
                    }
                  }
                </td>
              }
            </tr>
          }
        </tbody>
      </nz-table>
    </nz-row>
    }
  </nz-tab>
  <nz-tab nzTitle="Etiketten" [nzDisabled]="!isEdit">
    @if (isEdit) {
      <app-article-labels-table [article]="editObject" />
    }
  </nz-tab>
<nz-tab nzTitle="Umsatz">
  <app-article-sales-history-table
    [articleId]="editObject.id"
    [stores]="stores"
    [articleVariants]="editObject.articleVariants"
    [isNonPackable]="editObject.isNonPackable"
    />
</nz-tab>
<nz-tab nzTitle="Forecast" [nzDisabled]="!isEdit">
  @if (isEdit) {
    <app-article-sales-forecast
      [articleId]="editObject.id"
      [articleVariants]="editObject.articleVariants"
      [hasVariants]="editObject.hasVariants"
      />
  }
</nz-tab>
</nz-tabs>
}
</nz-spin>

<app-store-stocks-corrections-modal #correctionsModalComponent></app-store-stocks-corrections-modal>

<app-confirmation-modal
  #confirmationModalComponent
  (choice)="removeVariantsChoice($event)"
  contentText="Die Artikelvarianten werden gelöscht. Sind Sie sicher?"
></app-confirmation-modal>

<app-change-mhd-modal
  #changeMhdModalComponent
  (mhdChanged)="onMhdChanged($event); mhdChanged.emit()"
  [hideEanSearch]="true"
  />
